// @ts-ignore
export const updateMindbox = () => {
	if (typeof window === 'undefined') return

	return window[`PopMechanic`]?.update?.()
}
